<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deletePeriod">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="col-md-12">   
            <KTCard v-bind:title="page_title">
                <template v-slot:body>
                    <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                        <div class="m-portlet__body">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Dönem İsmi:</label>
                                <div class="col-lg-9">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="period.name">
                                    <div v-if="errors.name" :errors="errors">
                                        <b-badge v-for="error in errors.name" class="mr-1" :key="error.name" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Tutar:</label>
                                <div class="col-lg-9">
                                    <input type="number" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="period.price">
                                    <div v-if="errors.price" :errors="errors">
                                        <b-badge v-for="error in errors.price" class="mr-1" :key="error.price" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Başlangıç Tarihi:</label>
                                <div class="col-lg-9">
                                    <input type="date" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="period.start_date">
                                    <div v-if="errors.start_date" :errors="errors">
                                        <b-badge v-for="error in errors.start_date" class="mr-1" :key="error.start_date" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Bitiş Tarihi:</label>
                                <div class="col-lg-9">
                                    <input type="date" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="period.end_date">
                                    <div v-if="errors.end_date" :errors="errors">
                                        <b-badge v-for="error in errors.end_date" class="mr-1" :key="error.end_date" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>
                            
                            <template v-if="timeStamps">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleyen:</label>
                                    <div class="col-lg-9">
                                        {{ period.user_created_name }}
                                    </div>
                                </div>
                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ period.created_at | formatDateTime }}</span>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleyen:</label>
                                    <div class="col-lg-9">
                                        {{ period.user_updated_name }}
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ period.updated_at | formatDateTime }}</span>
                                    </div>
                                </div>

                        </template>
                          
                        </div>
                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-3"></div>
                                    <div class="col-lg-9">
                                        <!-- EKLEME BUTONLARI -->
                                        <template v-if="addButtons">
                                            <b-button
                                                v-if="hasPermission('periods.create')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="savePeriodAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Kaydet ve Geri Dön
                                            </b-button>
                                            
                                            <b-button
                                                v-if="hasPermission('periods.create')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="savePeriodAndAddNew()"
                                            >
                                            <i class="la la-save"></i>
                                                Kaydet ve Yeni Ekle
                                            </b-button>
                                        </template>

                                        <!-- GÜNCELLEME BUTONLARI -->
                                        <template v-if="editButtons">  
                                            <b-button
                                                v-if="hasPermission('periods.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="updatePeriodAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Güncelle ve Geri Dön
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('periods.update')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="updatePeriod()"
                                            >
                                            <i class="la la-save"></i>
                                                Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('periods.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            
                                            
                                        </template>

                                        <!-- GÖRÜNTÜLEME BUTONLARI -->
                                        <template v-if="viewButtons">
                                            <b-button
                                                v-if="hasPermission('periods.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('periods.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="changeFormToEditing()"
                                            >
                                            <i class="la la-edit"></i>
                                                Güncellemeyi Aktif Et
                                            </b-button>
 
                                        </template>   
                                        <template>
                                            <b-button 
                                                size="sm" 
                                                @click="$router.go(-1)">
                                                <i class="la la-undo"></i>
                                                İptal
                                            </b-button> 
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </KTCard>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
    
    </div>



    
</template>

<script>

import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_PERIOD_DATA } from "@/core/services/store/periods.module";
import { CREATE_PERIOD } from "@/core/services/store/periods.module";
import { UPDATE_PERIOD } from "@/core/services/store/periods.module";
import { DELETE_PERIOD } from "@/core/services/store/periods.module";
import constants from '@/core/constants/index';

//import Echo from 'laravel-echo';

export default {
    name: "periods-form",
    
    data() {
        return {
            dialog: false,
            period:{
                achievements: [],
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            page_title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            periods: {},
            options: [
                { value: '1', text: 'Evet', selected: true },
                { value: '0', text: 'Hayır' },
            ],

            value: [],
            regions: constants.REGIONS,
            visa_status: constants.VISA_STATUS,
                        
        };
    },
   
    methods: {
        savePeriodAndGoBack() {
            const data = this.period;
            const goBack = true;
            this.$store.dispatch(CREATE_PERIOD, {data, goBack})
        },

        savePeriodAndAddNew() {
            const data =  this.period;
            const goBack = false;
            this.$store.dispatch(CREATE_PERIOD, {data, goBack})
        },

        updatePeriodAndGoBack() {
            const data = this.period;
            const goBack = true;
            this.$store.dispatch(UPDATE_PERIOD, { data, goBack })
        },

        updatePeriod() {
            const data = this.period;
            const goBack = false;
            this.$store.dispatch(UPDATE_PERIOD, { data, goBack })
        },

        deletePeriod() {
            var itemToDelete = this.period.id;
            this.$store.dispatch(DELETE_PERIOD, { itemToDelete })
            .then(() => { 
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        changeFormToAdding(){
            this.page_title = "Dönem: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.page_title = "Dönem: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.page_title = "Dönem: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },

        addNewPeriodAchievementItem(row) {
            for(var i=0; i<row; i++){
                this.period.achievements.push(
                    { description: null, event_date: null }
                )
            }
        },

        deletePeriodAchievementItem(index) {
            this.period.achievements.splice(index, 1);
        },

    },


    components: {
        KTCard,
        //Multiselect
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
        this.$store.dispatch('createPeriodForm');
        this.period.is_active = 1;
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_PERIOD_DATA, { id })
            .then(( response ) => {
                this.period = response.data;
                this.period.user_created_name = response.data.user_created_name[0].name;
                this.period.user_updated_name = response.data.user_updated_name[0].name;
            })
        }
    },

    mounted() {
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }
    },

    computed: {
        ...mapGetters(["currentUserMenu"]),

        ...mapState({
            loading: state => state.periods.loading,
            row: state => state.periods.row,
            errors: state => state.periods.errors,
            isDisabled: state => state.periods.isDisabled,
            //user: state => state.users.user_data
        })
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>
